import React, { useEffect, useState } from "react";
import { RiStore3Fill, RiAuctionFill } from "react-icons/ri";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { server } from "../server";
import { toast } from "react-toastify";

export default function Homepage() {
  const navigate = useNavigate();
  const [shops, setShops] = useState([]);
  const [loading, setLoading] = useState(false);

  const getAllShops = async () => {
    try {
      setLoading(true);
      const { data } = await axios.get(`${server}/shop/all`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("bvmToken")}`,
        },
      });
      setShops(data?.data || []);
      setLoading(false);
    } catch (e) {
      setLoading(false);
      toast.error(e?.response?.data?.message || "Failed to fetch shops");
    }
  };

  useEffect(() => {
    getAllShops();
  }, []);

  const handleShopClick = (shop) => {
    navigate(`/my/shopDetails`, { state: { shopId: shop.id || shop._id } });
  };

  return (
    <div className="p-6 bg-slate-50 min-h-screen">
      <div className="mb-8">
        <h1 className="text-3xl font-bold text-slate-800 tracking-tight">Dashboard</h1>
        <p className="text-slate-500 mt-1">Welcome back, here's what's happening today.</p>
      </div>

      {/* Shops Grid */}
      <div className="mb-8">
        <div className="flex justify-between items-center mb-4">
          <h2 className="text-xl font-bold text-slate-800">All Shops</h2>
          <button
            onClick={() => navigate("/my/addNewShop")}
            className="px-4 py-2 bg-blue-600 text-white text-sm font-medium rounded-lg hover:bg-blue-700 transition-colors"
          >
            Add New Shop
          </button>
        </div>

        {loading ? (
          <div className="text-center py-12">
            <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto mb-4"></div>
            <p className="text-slate-600">Loading shops...</p>
          </div>
        ) : shops.length === 0 ? (
          <div className="bg-white p-12 rounded-xl shadow-sm text-center">
            <RiStore3Fill className="text-6xl text-slate-300 mx-auto mb-4" />
            <p className="text-slate-600 font-medium">No shops available</p>
            <p className="text-slate-500 text-sm mt-2">Get started by adding your first shop</p>
          </div>
        ) : (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
            {shops.map((shop, index) => (
              <div
                key={shop.id || shop._id || index}
                onClick={() => handleShopClick(shop)}
                className="bg-gradient-to-br from-white to-blue-50 p-6 rounded-xl shadow-sm hover:shadow-lg transition-all duration-300 cursor-pointer border border-blue-100 hover:border-blue-300 group"
              >
                <div className="flex items-start justify-between mb-4">
                  <div className="p-3 bg-blue-100 rounded-lg group-hover:bg-blue-200 transition-colors">
                    <RiStore3Fill className="text-2xl text-blue-600" />
                  </div>
                  <span className="text-xs font-medium px-2 py-1 bg-green-100 text-green-700 rounded-full">
                    Active
                  </span>
                </div>

                <div className="mb-4">
                  <h3 className="text-lg font-bold text-slate-800 mb-1 group-hover:text-blue-600 transition-colors">
                    {shop.shopName}
                  </h3>
                  <p className="text-sm text-slate-500">Code: {shop.shopCode}</p>
                </div>

                <div className="pt-4 border-t border-blue-100">
                  <div className="flex items-center justify-between">
                    <span className="text-xs font-medium text-slate-500">Highest Bid</span>
                    <div className="flex items-center gap-1">
                      <RiAuctionFill className="text-green-600" />
                      <span className="text-lg font-bold text-green-600">
                        ₹{shop.heighestAuctionBidAmount || 0}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
